var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99407 0.872559C6.15304 0.872559 3.51647 3.20345 3.85162 6.21712C3.98884 8.26954 4.35662 10.0614 5.14288 11.3623C5.97237 12.7347 7.24926 13.5228 8.99407 13.5228C9.8386 13.5228 10.5948 13.3399 11.2508 12.9586C11.9058 12.5778 12.4133 12.0268 12.8036 11.3626C13.5673 10.0631 13.9185 8.26672 14.0758 6.20594C14.302 3.242 11.8918 0.872559 8.99407 0.872559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9264 22.1937L16.4484 18.6716C18.3373 20.0159 20.9752 19.841 22.6692 18.147C24.5582 16.2579 24.5582 13.1952 22.6692 11.3062C20.7801 9.41714 17.7174 9.41714 15.8284 11.3062C14.1457 12.9888 13.9619 15.6027 15.2768 17.4888L8.70403 24.0616C8.37893 24.3866 8.37893 24.9137 8.70403 25.2388C9.02909 25.5639 9.55618 25.5639 9.88125 25.2388L11.7488 23.3712L13.7182 25.2522C14.0506 25.5697 14.5776 25.5576 14.8951 25.2251C15.2127 24.8926 15.2006 24.3657 14.8681 24.0482L12.9264 22.1937ZM17.0056 12.4834C15.7667 13.7223 15.7667 15.7309 17.0056 16.9697C18.2445 18.2086 20.2531 18.2086 21.4919 16.9697C22.7308 15.7309 22.7308 13.7223 21.4919 12.4834C20.2531 11.2446 18.2445 11.2446 17.0056 12.4834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48979 21.3908C8.82942 21.3908 9.15519 21.2559 9.39535 21.0157L12.9268 17.4842C13.1091 17.302 13.1615 17.0292 13.0801 16.7847C12.9141 16.2862 12.8101 15.7715 12.7682 15.2528C12.7424 14.9339 12.5109 14.6577 12.1913 14.6425C12.0966 14.638 12.0012 14.6357 11.9053 14.6357H6.00857C2.73759 14.6357 0.0859375 17.2874 0.0859375 20.5584C0.0859375 21.0181 0.458643 21.3908 0.91837 21.3908H8.48979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.44c87473d52bdada500e9979ef897020.svg";
export { ForwardRef as ReactComponent };